define('pages/englishlive2016/modeDetector',[
    '$', 
    'shared/lib/Emitter', 
    'shared/util/throttle'
], function($, Emitter, throttle) {
    'use strict';

    var BREAK_4_TABLET = 1366;
    var BREAK_4_MOBILE = 1226;

    var $win = $(window);
    var emitter = new Emitter();

    function setMode() {
        if (window.innerWidth <= BREAK_4_MOBILE) {
            if (emitter.mode != 'mobile') {
                emitter.mode = 'mobile';
                emitter.emit('change', emitter.mode);
            }
        }
        else {
            if (emitter.mode != 'desktop') {
                emitter.mode = 'desktop';
                emitter.emit('change', emitter.mode);
            }   
        }
    }

    setMode();
    $win.on('resize', throttle(setMode));
    emitter.BREAK_4_MOBILE = BREAK_4_MOBILE;

    return emitter;
});
